export const isSuitestreamInstalledApp = (app) => {
  const packageName = String(app?.package_name || app?.packageName || '').toLowerCase();
  const appName = String(app?.app_name || app?.appName || '').toLowerCase();
  return packageName.includes('suitestream') || appName.includes('suitestream')
    || /^com\.soundcheckvn\.soundscreen\.soundscreenapp(?:\.dev)?$/.test(packageName);
};

export const isInstalledAppEnabled = (value) => {
  if (value === false || value === 0) return false;
  const normalized = String(value ?? '').trim().toLowerCase();
  return !['0', 'false', 'off', 'no'].includes(normalized);
};

export const normalizeInstalledApps = (apps = []) =>
  (Array.isArray(apps) ? apps : [])
    .map((app) => {
      const packageName = String(app?.package_name || app?.packageName || '').trim();
      return {
        package_name: packageName,
        app_name: String(app?.app_name || app?.appName || packageName).trim(),
        icon_url: app?.icon_url || app?.iconUrl || null,
        launchable: isInstalledAppEnabled(app?.launchable),
        enabled: isInstalledAppEnabled(app?.enabled),
      };
    })
    .filter((app) => app.package_name);

// The host player is launched through launch_suitestream, independently of the
// enabled preference used to choose external apps. A registered native player
// also proves Suitestream is present when its inventory omits its own package.
export const getSuitestreamLauncherApp = (apps = [], { registeredPlayer = false } = {}) => {
  const installed = normalizeInstalledApps(apps).find(isSuitestreamInstalledApp);
  if (installed && (registeredPlayer || installed.launchable)) return installed;
  return registeredPlayer ? { package_name: 'launch_suitestream', app_name: 'Suitestream' } : null;
};

export const getOperationalInstalledApps = (apps = []) =>
  normalizeInstalledApps(apps)
    .filter((app) => app.enabled && app.launchable && !isSuitestreamInstalledApp(app))
    .sort((a, b) => {
      const aName = String(a.app_name || a.package_name).toLowerCase();
      const bName = String(b.app_name || b.package_name).toLowerCase();
      return aName.localeCompare(bName);
    });

export const countExternalInstalledApps = (apps = []) =>
  normalizeInstalledApps(apps).filter((app) => !isSuitestreamInstalledApp(app)).length;

export const countLaunchableExternalApps = (apps = []) =>
  normalizeInstalledApps(apps)
    .filter((app) => app.launchable && !isSuitestreamInstalledApp(app))
    .length;
